import { useSelector } from "react-redux";
const OrderSummaryAmount = ({}) => {
  let productQuantity = useSelector(store => store.bag.bagListQuantity);    
  
    const bagIds = useSelector(store => store.bag.cartList);    
  const items = useSelector(store => store.allItems);
  const finalItems = items.filter(item => {
    const itemIndex = bagIds.indexOf(item.id);
    return itemIndex >= 0;
  })    
    //let totalItem = bagIds.length;
    let CONVENIENCE_FEES = 45;
    const REQUIRE_AMOUNT = 499;
    let totalMRP = 0;
    let totalDiscount = 0;

    let productQty = 1;
    finalItems.forEach((bagItem) => {
      productQty = productQuantity.find(el => el.id === bagItem.id);
      if(bagItem.product_offer>0){
        totalMRP += (bagItem.product_price - bagItem.product_price * bagItem.product_offer/100) * productQty.quantity;        
      } else {
        totalMRP += bagItem.product_price * productQty.quantity;

      }
      
    })
    CONVENIENCE_FEES = (totalMRP - totalDiscount) > REQUIRE_AMOUNT ? 0 : CONVENIENCE_FEES;
    let finalPayment = totalMRP - totalDiscount + CONVENIENCE_FEES;    
    return <>You have to pay Total Amount &#x20B9;{Math.round(finalPayment)} cash on delivery</>
}
export default OrderSummaryAmount;